<template>
  <div class="page_con">
    <div class="m_table">
      <div class="empty_wrap" v-if="items.length <= 0">
        <div class="empty">
          <span>내역이 존재하지 않습니다.</span>
        </div>
      </div>
      <ul class="m_table_ul" v-else ><!--'.nav 바로 밑에 테이블이 오는 경우 border 제거'-->
        <li class="m_table_li" v-for="(item, index) in items" :key="index">
          <div class="col">
            <div class="dl">
              <span class="dt">주문번호</span>
              <!-- 주문번호 미표출되는 오류 해결 (서남아이에스 임현아, 2024-08-20) -->
              <span class="dd" v-if="isU === '/edu/completed'">{{ isOnline === true ? item.edu.onlineEduCode : item.edu.offlineEduCode }}</span>
              <span class="dd" v-if="isU === '/edu/offline/done'">{{ eduType.onlineType === 1 ? item.edu.onlineEduCode : item.edu.offlineEduCode }}</span>
            </div>
            <div class="m_table_ttl">
              <span>{{$ConstCode.CODE_SALES_TYPE[item.edu.salesType].name }} ({{ $ConstCode.CODE_INDUSTRY_TYPE[item.edu.industryType].name }})</span><br>
              <span>{{ item.edu.businessName }}</span>
            </div>
            <div class="date"><span>{{ $Util.isEmpty(item.edu.endDate) ? '-' : `${$moment(item.edu.endDate).format('YYYY-MM-DD HH:mm')} 완료` }}</span></div>
          </div>
          <div class="col fix110" v-if="isU === '/edu/completed'">
            <button class="btn bo" @click="fnPrint(item)" v-if="isOnline" :disabled="item.edu.isEnd === 2 || item.edu.positionType === 2 && item.edu.isHygiene !== 1">출력하기</button>
            <button class="btn bo" @click="fnPrint(item)" v-else :disabled="item.edu.isEnd === 2 || item.edu.positionType === 2 && item.edu.isHygiene !== 1">출력하기</button>
          </div>
          <div class="col fix110" v-if="isU === '/edu/offline/done'">
            <button class="btn bo" @click="fnPrint(item)" v-show='item.edu.isEnd !== 1'>출력하기</button>
          </div>
        </li>
      </ul>
      <main-bottom-banner v-bind:isURL="isURL" />
    </div>
  </div>
</template>

<script>
import MainBottomBanner from '@/components/pages/main/bottombanner/index'

export default {
  name: 'edu-done-list-index',
  components: {MainBottomBanner},
  props: {
    pageInfo: {
      type: [Array, Object],
      default: () => {}
    },
    items: {
      type: [Array, Object],
      default: () => {}
    },
    eduType: {
      type: [Array, Object],
      default: () => {}
    },
    isOnline: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isURL: this.eduType.industryType === 1 ? '16' : (this.eduType.industryType === 2 ? '21': '26'),
      isU : this.$router.currentRoute.path
    }
  },
  watch: {
    'eduType.industryType': async function (){
      if (this.eduType.industryType === 1) {
        this.isURL = '16'
      }
      if (this.eduType.industryType === 2) {
        this.isURL = '21'
      }
      if (this.eduType.industryType === 3) {
        this.isURL = '26'
      }
    }
  },
  created() {
    if(this.$route.path === '/edu/offline/done') {
      if (this.eduType.industryType === 1) {
        this.isURL = '16'
      }
      if (this.eduType.industryType === 2) {
        this.isURL = '21'
      }
      if (this.eduType.industryType === 3) {
        this.isURL = '26'
      }
    } else if (this.$route.path === '/edu/completed') {
      this.isURL = '33'
    }
  },
  methods: {
    fnPrint: function(item) {
      this.$emit('print', item)
    }
  }
}
</script>

<style scoped>

</style>
